import { inject, Injectable } from '@angular/core';

import { BROWSER_WALLET_GLOBAL } from '@drf/core';

const WALLET_AUTO_CONNECT_DISABLED_KEY = 'drf-wallet-auto-connect-disabled';
const AUTO_CONNECT_DISABLED_VALUE = 'true';

@Injectable({ providedIn: 'root' })
export class WalletAutoConnectPreferenceService {
  readonly #browserGlobal = inject(BROWSER_WALLET_GLOBAL);

  /** Persists the user's choice to prevent silent wallet restore on reload. */
  disableAutoConnect(): void {
    try {
      this.#getStorage()?.setItem(WALLET_AUTO_CONNECT_DISABLED_KEY, AUTO_CONNECT_DISABLED_VALUE);
    } catch {
      return;
    }
  }

  /** Clears the local suppression flag after an explicit user connect. */
  enableAutoConnect(): void {
    try {
      this.#getStorage()?.removeItem(WALLET_AUTO_CONNECT_DISABLED_KEY);
    } catch {
      return;
    }
  }

  /** Reports whether init may restore an already authorized wallet. */
  isAutoConnectEnabled(): boolean {
    try {
      return this.#getStorage()?.getItem(WALLET_AUTO_CONNECT_DISABLED_KEY) !== AUTO_CONNECT_DISABLED_VALUE;
    } catch {
      return true;
    }
  }

  /** Returns localStorage only when the browser global exposes the needed API. */
  #getStorage(): Pick<Storage, 'getItem' | 'removeItem' | 'setItem'> | null {
    const storage = this.#browserGlobal.localStorage;

    if (
      !storage ||
      typeof storage.getItem !== 'function' ||
      typeof storage.removeItem !== 'function' ||
      typeof storage.setItem !== 'function'
    ) {
      return null;
    }

    return storage;
  }
}
